import React from 'react';
import { JSMABridge } from '@indeed/jsma-js-bridge';
import ApplyForMePromoModal from './ApplyForMePromoModal';

/** Route the native JSMABridge webview modal loads to present the promo. */
export const APPLY_FOR_ME_PROMO_PATH = '/auto-apply/apply-for-me-promo';

/**
 * Standalone page rendered inside a native JSMABridge webview modal. It reuses the
 * shared {@link ApplyForMePromoModal} (full screen to fill the webview) and reports
 * the user's choice back to the parent webview, which performs the suppression
 * bookkeeping and navigation.
 */
const ApplyForMePromoPage: React.FC = () => {
    const dismiss = (result: 'set-up' | 'continue' | 'close') => {
        if (JSMABridge.isAvailable()) {
            void JSMABridge.dismissModalWithWebView({ result });
        }
    };

    return (
        <ApplyForMePromoModal
            isOpen
            fullScreen
            inNativeBottomSheet
            onSetUp={() => dismiss('set-up')}
            onContinue={() => dismiss('continue')}
            onClose={() => dismiss('close')}
        />
    );
};

export default ApplyForMePromoPage;
